declare global {
  interface Element {
    __vue__?: Vue;
  }
}
import Vue, { VNode, CreateElement } from 'vue';
interface RenderFn {
  (h: CreateElement): VNode;
}
export default class BodyMounter {
  node: Element | null = null ;
  vm: Vue | null = null;
  mount (renderFn: RenderFn) {
    this.node = document.createElement('div');
    document.body.appendChild(this.node);
    const mountingNode = this.node.appendChild(document.createElement('div'));
    const vm = document.querySelector('#app')?.__vue__;
    this.vm = new Vue({
      name: 'BodyMounter',
      parent: vm,
      render (h) {
        return renderFn(h);
      },
    }).$mount(mountingNode);
    return this.vm;
  }

  destroy (): void {
    if (this.vm) this.vm.$destroy();
    if (this.node?.parentNode) this.node.parentNode.removeChild(this.node);
  }
}
